<template>
  <b-container id="requestForm" class="mt-5">
    <b-row align-h="center">
      <b-col md="10" lg="7" xl="6">
        <b-form ref="form" @submit.prevent="doRegister" v-if="show">
          <b-form-group
            id="firstNameGroup"
            label="Vorname"
            label-align="left"
            label-align-md="right"
            label-cols-md="4"
            label-for="fistNameInput"
          >
            <b-form-input
              id="fistNameInput"
              type="text"
              v-model="firstName"
              required
            />
          </b-form-group>
          <b-form-group
            id="lastNameGroup"
            label="Nachname"
            label-align="left"
            label-align-md="right"
            label-cols-md="4"
            label-for="lastNameInput"
          >
            <b-form-input
              id="lastNameInput"
              type="text"
              v-model="lastName"
              required
            />
          </b-form-group>
          <b-form-group
            id="emailGroup"
            label="E-Mail"
            label-align="left"
            label-align-md="right"
            label-cols-md="4"
            label-for="emailInput"
          >
            <b-form-input
              id="emailInput"
              type="email"
              v-model="email"
              required
            />
          </b-form-group>
          <b-form-group
            id="passwordGroup"
            label="Passwort"
            label-align="left"
            label-align-md="right"
            label-cols-md="4"
            label-for="passwordInput"
          >
            <b-form-input
              id="passwordInput"
              type="password"
              v-model="password"
              required
            />
            <b-form-invalid-feedback
              v-if="this.password"
              :state="passwordValidation"
            >
              Mindestens 8 Zeichen eingeben
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="repeatPasswordGroup"
            label="Passwort Wiederholung"
            label-align="left"
            label-align-md="right"
            label-cols-md="4"
            label-for="repeatPasswordInput"
          >
            <b-form-input
              id="repeatPasswordInput"
              type="password"
              v-model="passwordRepeat"
              required
            />
            <b-form-invalid-feedback
              v-if="this.passwordRepeat"
              :state="passwordRepeatValidation"
            >
              Passwörter müssen gleich sein
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            id="servicesGroup"
            label-align="left"
            label-align-md="right"
            label-cols-md="4"
            label-for="servicesCheckboxes"
            :label="$t('T5')"
          >
            <service-picker
              align="left"
              :all-services="servicesOptions"
              v-model="pickedServices"
            />
          </b-form-group>
          <b-alert
            dismissible
            @dismissed="error = ''"
            variant="danger"
            :show="error.length > 0"
            >{{ error }}
          </b-alert>
          <b-alert
            dismissible
            @dismissed="success = ''"
            variant="success"
            :show="success.length > 0"
            >{{ success }}
          </b-alert>
          <b-button
            class="mt-4 mt-md-auto w-100"
            type="submit"
            variant="primary"
            :disabled="isInvalid || isLoading"
          >
            <b-spinner small v-show="isLoading" />
            Registrieren
          </b-button>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ServicePicker from "../components/ServicePicker";
export default {
  name: "Register",
  components: { ServicePicker },
  data() {
    return {
      isLoading: false,
      show: true,
      error: "",
      success: "",
      firstName: "",
      lastName: "",
      email: "",
      password: "",
      passwordRepeat: "",
      servicesOptions: [],
      pickedServices: []
    };
  },
  created() {
    this.$http
      .get("/service/all")
      .then(response => (this.servicesOptions = response.data.data));
  },
  methods: {
    doRegister() {
      let form = new FormData();
      form.append("firstName", this.firstName);
      form.append("lastName", this.lastName);
      form.append("email", this.email);
      form.append("password", this.password);
      for (let serviceId of this.pickedServices) {
        form.append("services[]", serviceId);
      }
      this.isLoading = true;
      this.$http
        .post("/user/create", form)
        .then(response => {
          this.resetForm();
          this.success = response.data.message;
        })
        .catch(error => {
          this.error = error.response.data.message;
          this.success = "";
        })
        .finally(() => (this.isLoading = false));
    },
    resetForm() {
      this.error = "";
      this.success = "";
      this.firstName = "";
      this.lastName = "";
      this.email = "";
      this.password = "";
      this.passwordRepeat = "";
      this.pickedServices = [];
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  },
  computed: {
    passwordValidation() {
      return this.password.length >= 8;
    },
    passwordRepeatValidation() {
      return this.password === this.passwordRepeat;
    },
    isInvalid() {
      return (
        !this.passwordRepeatValidation ||
        !this.passwordValidation ||
        Object.values(this.$refs["form"])
          .filter(element => element)
          .some(input => !input.validity.valid)
      );
    }
  }
};
</script>

<style scoped></style>
